import { AssistiveDevice } from '../../SinglePatientDetails/Header/PatientDetails/types';

export enum goalsTypes {
  objective,
  adherence,
}

export const MOBILITY_AID_OPTIONS = [
  {
    label: 'None',
    value: 'none',
    isIntake: true,
    serverValue: AssistiveDevice.NONE,
  },
  {
    label: 'Walker',
    value: 'walker',
    isIntake: true,
    serverValue: AssistiveDevice.WALKER,
  },
  {
    label: 'Rollator',
    value: 'rollator',
    isIntake: true,
    serverValue: AssistiveDevice.ROLLATOR,
  },
  {
    label: 'Crutches',
    value: 'crutches',
    isIntake: true,
    serverValue: AssistiveDevice.CRUTCH_DOUBLE,
  },
  {
    label: 'Crutch',
    value: 'crutch',
    isIntake: true,
    serverValue: AssistiveDevice.CRUTCH_SINGLE,
  },
  {
    label: 'Cane',
    value: 'cane',
    isIntake: true,
    serverValue: AssistiveDevice.CANE,
  },
  {
    label: 'Walking poles',
    value: 'walking-poles',
    serverValue: AssistiveDevice.POLES,
  },
  {
    label: 'Brace',
    value: 'brace',
  },
  {
    label: 'Wheel chair',
    value: 'wheel-chair',
    isIntake: true,
    serverValue: AssistiveDevice.Wheelchair,
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export enum GenderEnum {
  Male = 0,
  Female = 1,
  Other = 2,
}

export const GENDER_OPTIONS = [
  { label: 'Male', value: GenderEnum.Male },
  { label: 'Female', value: GenderEnum.Female },
  { label: 'Other', value: GenderEnum.Other },
];

export const AFFECTED_SIDE_OPTIONS = [
  {
    label: 'None',
    value: 0,
  },
  {
    label: 'Right',
    value: 1,
  },
  {
    label: 'Left',
    value: 2,
  },
  {
    label: 'Both',
    value: 3,
  },
];

export const HOW_DID_YOU_HEAR_OPTIONS = [
  {
    label: 'Facebook',
    value: 1,
  },
  {
    label: 'Google',
    value: 2,
  },
  {
    label: 'Bonesmart',
    value: 3,
  },
  {
    label: 'Physician',
    value: 4,
  },
  {
    label: 'Friend',
    value: 5,
  },
  { label: 'Other', value: 0 },
];

export const LIVING_STATUS_OPTIONS = [
  {
    label: 'None',
    value: 0,
  },
  {
    label: 'Alone',
    value: 1,
  },
  {
    label: 'Partner',
    value: 2,
  },
  {
    label: 'Children',
    value: 3,
  },
  {
    label: 'Other Family Member',
    value: 4,
  },
  {
    label: 'Caregiver',
    value: 5,
  },
];

export const EMPLOYMENT_OPTIONS = [
  {
    label: 'None',
    value: 0,
  },
  {
    label: 'Employed',
    value: 1,
  },
  {
    label: 'Unemployed',
    value: 2,
  },
  {
    label: 'Retired',
    value: 3,
  },
  {
    label: 'Part Time',
    value: 4,
  },
];

export const AGG_PARAMETER_OPTIONS = [
  {
    label: 'Walk Duration',
    value: 1,
  },
  // {
  //   label: 'Steps',
  //   value: 2,
  // },
  // {
  //   label: 'Tasks',
  //   value: 3,
  // },
  {
    label: 'Course days',
    value: 4,
  },
  // {
  //   label: 'Active Days',
  //   value: 5,
  // },
];

export const SCOPE_OPTIONS = [
  {
    label: 'Walk',
    value: 1,
    isObjective: true,
  },
  {
    label: 'Daily',
    value: 2,
  },
  {
    label: 'Weekly',
    value: 3,
  },
];

export const GOAL_TYPE_OPTIONS = [
  {
    label: 'personal goal',
    description: 'This is a goal set personally by the patient',
    value: 4,
    readOnly: true,
  },
  {
    label: 'subjective',
    value: 3,
  },
  {
    label: 'long',
    value: 2,
  },
  {
    label: 'short',
    value: 1,
  },
];

export const MONTH_OPTIONS = [
  {
    label: '1 month',
    value: 1,
  },
  {
    label: '2 months',
    value: 2,
  },
  {
    label: '3 months',
    value: 3,
  },
  {
    label: '4 months',
    value: 4,
  },
  {
    label: '5 months',
    value: 5,
  },
  {
    label: '6 months',
    value: 6,
  },
];

export enum goalModes {
  new = 'new',
  redo = 'redo',
  edit = 'edit',
}

export const ADHERENCE_OPTIONS = [
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4',
    value: 4,
  },
  {
    label: '5',
    value: 5,
  },
  {
    label: '6',
    value: 6,
  },
  {
    label: '7',
    value: 7,
  },
];

export const OBJECTIVE_UNITS_OPTIONS = [
  {
    label: 'Walk Duration',
    value: 1,
    filedLabel: 'Weekly Duration (minutes)',
    goalText: 'minutes a week',
    goalType: 'walk',
    convertNum: 60,
  },
  {
    label: 'Course days',
    value: 4,
    filedLabel: 'Days a week',
    goalText: 'days a week',
    goalType: 'exercise',
    convertNum: 1,
  },
];
